import { getApiBaseUrl, SALON_API_PREFIX } from './apiConfig';
import { fetchWithTimeout } from './fetchWithTimeout';

/**
 * Look up a prior customer by mobile (server picks one profile if several share the number).
 * @returns {Promise<{ found: boolean, salon_reference?: string, name?: string, ... }>}
 */
export async function lookupSalonCustomerByPhone(mobile, appSessionToken = null) {
  const API = (getApiBaseUrl() || '').replace(/\/$/, '');
  const body = { mobile_number: String(mobile || '').trim() };
  if (appSessionToken && String(appSessionToken).trim()) {
    body.app_session_token = String(appSessionToken).trim();
  }
  const res = await fetchWithTimeout(`${API}${SALON_API_PREFIX}/customer/lookup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    timeoutMs: 20000,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Lookup failed');
  }
  return data;
}

/**
 * Whether a normalized mobile already exists in any SalonUserInfo row (new customer must use another number).
 */
export async function checkSalonMobileExists(mobile, appSessionToken = null) {
  const API = (getApiBaseUrl() || '').replace(/\/$/, '');
  const body = { mobile_number: String(mobile || '').trim() };
  if (appSessionToken && String(appSessionToken).trim()) {
    body.app_session_token = String(appSessionToken).trim();
  }
  const res = await fetchWithTimeout(`${API}${SALON_API_PREFIX}/customer/mobile-exists`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    timeoutMs: 20000,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || 'Check failed');
  }
  return { exists: !!data.exists };
}
